let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dhDvQ")).then(() => parcelRequire('02tsy'));